<template>
  <header class="oa-page-header">
    <div class="oa-page-heading">
      <el-button v-if="back" class="oa-back" type="text" icon="el-icon-back" @click="$emit('back')">{{ backLabel }}</el-button>
      <div><h1>{{ title }}</h1><p v-if="description"><oa-copy-number v-if="copyableDescription" :value="description" /><template v-else>{{ description }}</template></p></div>
    </div>
    <div class="oa-header-actions"><slot /></div>
  </header>
</template>
<script>
import OaCopyNumber from './OaCopyNumber'
export default { name: 'OaPageHeader', components: { OaCopyNumber }, props: { title: String, description: String, copyableDescription: Boolean, back: Boolean, backLabel: { type: String, default: '返回' } } }
</script>
